<app-page>

  <app-page-nav>
    <app-sidebar class="sidebar" role="sidebar"></app-sidebar>
  </app-page-nav>

  <app-page-content>

    <section class="is-flex is-column">

      <router-outlet></router-outlet>

    </section>

  </app-page-content>

</app-page>